import api from "@/api/viktor"

export async function getAssessmentSummary(uuid: string) {
  const response = await api({
    method: "get",
    url: `/user/${uuid}/assessments-summary`,
  })

  return response
}
